<template>
    <div id="kong">
        <div>
            <!-- 
            <p>base64加密后：{{nextData}}</p>
            <p>base64解密后：{{next2Data}}</p>-->
            <!-- <p>解秋风手机号:{{phone}}</p> -->
        </div>
        <el-dialog
            custom-class="small-dialog-box"
            title="绑定手机"
            :close-on-click-modal="false"
            v-if="dialogData.dialogFormVisible"
            :visible.sync="dialogData.dialogFormVisible"
            :show-close="false"
            center
            width="400px"
        >
            <el-form :model="dialogData.form" label-width="80px" :rules="rules" ref="form">
                <el-form-item label="手机" prop="phone">
                    <el-input
                        placeholder="请输入手机号"
                        v-model.trim="dialogData.form.phone"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="temp">
                    <el-input placeholder="验证码" v-model="dialogData.form.temp" class="yzm">
                        <el-button
                            slot="append"
                            :disabled="disabledyzm"
                            @click="getYZMFW()"
                        >{{btntxt}}</el-button>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" type="danger" @click="submitPhoneW('form')" class="red">确 定</el-button>
                <el-button size="small" @click="cancle()">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import rules from "@/common/rules";
let Base64 = require("js-base64").Base64;
export default {
    name: "kong",
    data() {
        const validatePhone = (rule, value, callback) => {
            const val = value.trim();
            if (val === "") {
                callback(new Error("请输入手机号"));
            } else if (!/^1\d{10}$/.test(val)) {
                callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        return {
            // nextData: "",
            // next2Data: "",
            // qiufeng:"",
            phone: "",
            temp:'',
            wxId: "",
            rules: {
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    },
                    {
                        validator: validatePhone,
                        trigger: ["blur", "change"]
                    }
                ],
                temp: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ]
            },
            dialogData: {
                dialogFormVisible: false,
                form: {
                     phone: "",
                     temp: ""
                }
            },
            btntxt: "获取验证码",
            disabledyzm: false,
            time: 60,
            ifWeixinBind:null,//是否走绑定true绑定false不绑定
        };
    },
    created(){
       this.ifWeixinBind =JSON.parse(this.$route.query.ifWeixinBind)
        if(this.ifWeixinBind ===false){//不走微信绑定
              this.goLogin() 
        }
    },
    mounted() {
        // this.nextData = Base64.encode(this.preData); //base64加密
        // this.next2Data = Base64.decode(this.nextData); //base64解密
        // this.qiufeng = Base64.decode("MTg4MTEzNTc3MzY");
        // console.log(this.getUrlKey("phone"));
        this.wxId = Base64.decode(this.getUrlKey("wxId"));
        if (this.getUrlKey("phone")) {
            //有手机号
            this.phone = Base64.decode(this.getUrlKey("phone"));
            this.getUserInfoByW(this.phone, this.wxId);
        } else {
            this.dialogData.dialogFormVisible = true;
        }
        // console.log(this.phone);
    },
    methods: {
        //取消微信登陆
        cancle() {
            let that = this;
            that.dialogData.dialogFormVisible = false;
            that.$router.replace({
                path: "/login"
            });
        },

        // 获取验证码
        getYZMFW() {
            let that = this;
            let params = {
                phone: that.dialogData.form.phone
            };
            let url = "user/phone/sendCodeToPhone";
            that.$http
                .post(url, params)
                .then(res => {
                    if (res.data.code == 200) {
                        that.$message({
                            message: "验证码发送成功",
                            type: "success"
                        });
                        that.disabledyzm = true;
                        that.timeryzm();
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    // that.$message.error("网络错误！");
                });
        },
        //微信绑定邮箱的确定
        submitPhoneW() {
            if(this.ifWeixinBind ===false){//走微信绑定
                return false
            }
            
            let that = this;
            this.$refs.form.validate(async valid => {
                if (!valid) return;
                let params = {
                    phone: that.dialogData.form.phone,
                    temp: that.dialogData.form.temp,
                    weixinId: that.$route.query.wxId,
                    token:that.$route.query.token,
                    refreshToken:that.$route.query.refreshToken,
                    mzsmStatus:1,
                    yhxyStatus:1
                };
                let url = "wxLogin/wxLoginBind";
                that.$http
                    .post(url, params)
                    .then(res => {
                        if (res.data.code == 200) {
                            that.dialogData.dialogFormVisible = false;
                            sessionStorage.clear();
                            sessionStorage.setItem("YS", false);
                            sessionStorage.setItem(
                                "userInfo",
                                JSON.stringify(res.data.data)
                            );

                            if (localStorage.getItem("loginBeforeUrl")) {
                                window.location.href = localStorage.getItem(
                                    "loginBeforeUrl"
                                );
                                localStorage.removeItem("loginBeforeUrl");
                            } else {
                                that.$router.push({
                                    path: "/index"
                                });
                            }
                            that.$message({
                                message: "微信登录成功",
                                type: "success"
                            });
                            if (sessionStorage.getItem("userInfo")) {
                                // 刷新兄弟组件
                                let NewPage =
                                    "_empty" +
                                    "?time=" +
                                    new Date().getTime() / 500;
                                this.$router.push(NewPage);
                                this.$router.go(-1);
                            }
                        } else {
                            that.$message.error(res.data.msg);
                        }
                    })
                    .catch(() => {
                        // that.$message.error("网络错误！");
                    });
            });
        },
        //微信根据手机号获取登陆信息
        getUserInfoByW(phone, weixinId) {
            let that = this;
            let params = {
                phone: phone,
                weixinId: weixinId
            };
            let url = "user/phoneLogin";
            that.$http
                .post(url, params)
                .then(res => {
                    if (res.data.code == 200) {
                        sessionStorage.clear();
                        sessionStorage.setItem("YS", false);
                        sessionStorage.setItem(
                            "userInfo",
                            JSON.stringify(res.data.data)
                        );
                        sessionStorage.setItem(
                            "token",
                            JSON.stringify(res.data.data.token)
                        );
                        if (localStorage.getItem("loginBeforeUrl")) {
                            window.location.href = localStorage.getItem(
                                "loginBeforeUrl"
                            );
                            localStorage.removeItem("loginBeforeUrl");
                        } else {
                            that.$router.push({
                                path: "/index"
                            });
                        }
                        that.$message({
                            message: "微信登录成功",
                            type: "success"
                        });
                        // 刷新兄弟组件
                        if (sessionStorage.getItem("userInfo")) {
                            let NewPage =
                                "_empty" +
                                "?time=" +
                                new Date().getTime() / 500;
                            this.$router.push(NewPage);
                            this.$router.go(-1);
                        }
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                });
        },
        goLogin(){
            let that = this;
            sessionStorage.setItem("token", that.$route.query.token);
            //已经绑了微信直接登陆
            let url = "user/userInfo";
            that.$http
                .get(url)
                .then(res => {
                    if (res.data.code == 200) {
                        sessionStorage.clear();
                        sessionStorage.setItem("YS", false);

                        sessionStorage.setItem(
                            "userInfo",
                            JSON.stringify(res.data.data)
                        );
                        sessionStorage.setItem(
                            "token",
                            JSON.stringify(res.data.data.token)
                        );
                        if (localStorage.getItem("loginBeforeUrl")) {
                            window.location.href = localStorage.getItem(
                                "loginBeforeUrl"
                            );
                            localStorage.removeItem("loginBeforeUrl");
                        } else {
                            that.$router.push({
                                path: "/index"
                            });
                        }
                        that.$message({
                            message: "微信登录成功",
                            type: "success"
                        });
                        // 刷新兄弟组件
                        if (sessionStorage.getItem("userInfo")) {
                            let NewPage =
                                "_empty" +
                                "?time=" +
                                new Date().getTime() / 500;
                            this.$router.push(NewPage);
                            this.$router.go(-1);
                        }
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/kong.vue